/**
 * 常用字符类工具函数
 * @author gabewu
 */

import emojiRegex from 'emoji-regex';
import { htmlFilter } from './robotMsgFilter';
import FaceDict from '@/utils/faceDict';
import i18n from '@/i18n';
const emojiregex = emojiRegex();
const urlregex = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]', 'g');

function htmlEscape(text: string) {
  return text.replace(/['<>"`]/g, (match/* , pos, originalText */) => {
    switch (match) {
      case '\'':
        return '&#39;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case '`':
        return '&#96;';
      default:
        return '';
    }
  });
}

function emojiEscape(text: string) {
  return text.replace(emojiregex, '<span class="emoji">$&</span>');
}

function urlEscape(text: string) {
  return text.replace(urlregex, '<a href="$&" target="_blank">$&</a>');
}

function generateUUID() {
  return Date.now() * 1000 + Math.floor(Math.random() * 1000);
}
const faceTipMap: any = {
  0: {
    TIP: '[惊讶]',
  },
  1: {
    TIP: '[撇嘴]',
  },
  2: {
    TIP: '[色]',
  },
  3: {
    TIP: '[发呆]',
  },
  4: {
    TIP: '[得意]',
  },
  5: {
    TIP: '[流泪]',
  },
  6: {
    TIP: '[害羞]',
  },
  7: {
    TIP: '[闭嘴]',
  },
  8: {
    TIP: '[睡]',
  },
  9: {
    TIP: '[大哭]',
  },
  10: {
    TIP: '[尴尬]',
  },
  11: {
    TIP: '[发怒]',
  },
  12: {
    TIP: '[调皮]',
  },
  13: {
    TIP: '[呲牙]',
  },
  14: {
    TIP: '[微笑]',
  },
  15: {
    TIP: '[难过]',
  },
  16: {
    TIP: '[酷]',
  },
  17: {
    TIP: '[非典]',
  },
  18: {
    TIP: '[抓狂]',
  },
  19: {
    TIP: '[吐]',
  },
  20: {
    TIP: '[偷笑]',
  },
  21: {
    TIP: '[可爱]',
  },
  22: {
    TIP: '[白眼]',
  },
  23: {
    TIP: '[傲慢]',
  },
  24: {
    TIP: '[饥饿]',
  },
  25: {
    TIP: '[困]',
  },
  26: {
    TIP: '[惊恐]',
  },
  27: {
    TIP: '[流汗]',
  },
  28: {
    TIP: '[憨笑]',
  },
  29: {
    TIP: '[大兵]',
  },
  30: {
    TIP: '[奋斗]',
  },
  31: {
    TIP: '[咒骂]',
  },
  32: {
    TIP: '[疑问]',
  },
  33: {
    TIP: '[嘘...]',
  },
  34: {
    TIP: '[晕]',
  },
  35: {
    TIP: '[折磨]',
  },
  36: {
    TIP: '[衰]',
  },
  37: {
    TIP: '[骷髅]',
  },
  38: {
    TIP: '[敲打]',
  },
  39: {
    TIP: '[再见]',
  },
  40: {
    TIP: '[闪人]',
  },
  41: {
    TIP: '[发抖]',
  },
  42: {
    TIP: '[爱情]',
  },
  43: {
    TIP: '[跳跳]',
  },
  44: {
    TIP: '[找]',
  },
  45: {
    TIP: '[美眉]',
  },
  46: {
    TIP: '[猪头]',
  },
  47: {
    TIP: '[小狗]',
  },
  48: {
    TIP: '[钱]',
  },
  49: {
    TIP: '[拥抱]',
  },
  50: {
    TIP: '[灯泡]',
  },
  51: {
    TIP: '[酒杯]',
  },
  52: {
    TIP: '[音乐]',
  },
  53: {
    TIP: '[蛋糕]',
  },
  54: {
    TIP: '[闪电]',
  },
  55: {
    TIP: '[炸弹]',
  },
  56: {
    TIP: '[刀]',
  },
  57: {
    TIP: '[足球]',
  },
  58: {
    TIP: '[猫咪]',
  },
  59: {
    TIP: '[便便]',
  },
  60: {
    TIP: '[咖啡]',
  },
  61: {
    TIP: '[饭]',
  },
  62: {
    TIP: '[女]',
  },
  63: {
    TIP: '[玫瑰]',
  },
  64: {
    TIP: '[凋谢]',
  },
  65: {
    TIP: '[男]',
  },
  66: {
    TIP: '[爱心]',
  },
  67: {
    TIP: '[心碎]',
  },
  68: {
    TIP: '[药丸]',
  },
  69: {
    TIP: '[礼物]',
  },
  70: {
    TIP: '[吻]',
  },
  71: {
    TIP: '[会议]',
  },
  72: {
    TIP: '[电话]',
  },
  73: {
    TIP: '[时间]',
  },
  74: {
    TIP: '[太阳]',
  },
  75: {
    TIP: '[月亮]',
  },
  76: {
    TIP: '[强]',
  },
  77: {
    TIP: '[弱]',
  },
  78: {
    TIP: '[握手]',
  },
  79: {
    TIP: '[胜利]',
  },
  80: {
    TIP: '[邮件]',
  },
  81: {
    TIP: '[电视]',
  },
  82: {
    TIP: '[多多]',
  },
  83: {
    TIP: '[美女]',
  },
  84: {
    TIP: '[汉良]',
  },
  85: {
    TIP: '[飞吻]',
  },
  86: {
    TIP: '[怄火]',
  },
  87: {
    TIP: '[毛毛]',
  },
  88: {
    TIP: '[Q仔]',
  },
  89: {
    TIP: '[西瓜]',
  },
  90: {
    TIP: '[白酒]',
  },
  91: {
    TIP: '[汽水]',
  },
  92: {
    TIP: '[下雨]',
  },
  93: {
    TIP: '[多云]',
  },
  94: {
    TIP: '[雪人]',
  },
  95: {
    TIP: '[星星]',
  },
  96: {
    TIP: '[冷汗]',
  },
  97: {
    TIP: '[擦汗]',
  },
  98: {
    TIP: '[抠鼻]',
  },
  99: {
    TIP: '[鼓掌]',
  },
  100: {
    TIP: '[糗大了]',
  },
  101: {
    TIP: '[坏笑]',
  },
  102: {
    TIP: '[左哼哼]',
  },
  103: {
    TIP: '[右哼哼]',
  },
  104: {
    TIP: '[哈欠]',
  },
  105: {
    TIP: '[鄙视]',
  },
  106: {
    TIP: '[委屈]',
  },
  107: {
    TIP: '[快哭了]',
  },
  108: {
    TIP: '[阴险]',
  },
  109: {
    TIP: '[亲亲]',
  },
  110: {
    TIP: '[吓]',
  },
  111: {
    TIP: '[可怜]',
  },
  112: {
    TIP: '[菜刀]',
  },
  113: {
    TIP: '[啤酒]',
  },
  114: {
    TIP: '[篮球]',
  },
  115: {
    TIP: '[乒乓]',
  },
  116: {
    TIP: '[示爱]',
  },
  117: {
    TIP: '[瓢虫]',
  },
  118: {
    TIP: '[抱拳]',
  },
  119: {
    TIP: '[勾引]',
  },
  120: {
    TIP: '[拳头]',
  },
  121: {
    TIP: '[差劲]',
  },
  122: {
    TIP: '[爱你]',
  },
  123: {
    TIP: '[NO]',
  },
  124: {
    TIP: '[OK]',
  },
  125: {
    TIP: '[转圈]',
  },
  126: {
    TIP: '[磕头]',
  },
  127: {
    TIP: '[回头]',
  },
  128: {
    TIP: '[跳绳]',
  },
  129: {
    TIP: '[挥手]',
  },
  130: {
    TIP: '[激动]',
  },
  131: {
    TIP: '[街舞]',
  },
  132: {
    TIP: '[献吻]',
  },
  133: {
    TIP: '[左太极]',
  },
  134: {
    TIP: '[右太极]',
  },
  135: {
    TIP: '[招财进宝]',
  },
  136: {
    TIP: '[双喜]',
  },
  137: {
    TIP: '[鞭炮]',
  },
  138: {
    TIP: '[灯笼]',
  },
  139: {
    TIP: '[发财]',
  },
  140: {
    TIP: '[K歌]',
  },
  141: {
    TIP: '[购物]',
  },
  142: {
    TIP: '[邮件]',
  },
  143: {
    TIP: '[帅]',
  },
  144: {
    TIP: '[喝彩]',
  },
  145: {
    TIP: '[祈祷]',
  },
  146: {
    TIP: '[爆筋]',
  },
  147: {
    TIP: '[棒棒糖]',
  },
  148: {
    TIP: '[喝奶]',
  },
  149: {
    TIP: '[下面]',
  },
  150: {
    TIP: '[香蕉]',
  },
  151: {
    TIP: '[飞机]',
  },
  152: {
    TIP: '[开车]',
  },
  153: {
    TIP: '[高铁左车头]',
  },
  154: {
    TIP: '[车厢]',
  },
  155: {
    TIP: '[高铁右车头]',
  },
  156: {
    TIP: '[多云]',
  },
  157: {
    TIP: '[下雨]',
  },
  158: {
    TIP: '[钞票]',
  },
  159: {
    TIP: '[熊猫]',
  },
  160: {
    TIP: '[灯泡]',
  },
  161: {
    TIP: '[风车]',
  },
  162: {
    TIP: '[闹钟]',
  },
  163: {
    TIP: '[打伞]',
  },
  164: {
    TIP: '[彩球]',
  },
  165: {
    TIP: '[钻戒]',
  },
  166: {
    TIP: '[沙发]',
  },
  167: {
    TIP: '[纸巾]',
  },
  168: {
    TIP: '[药]',
  },
  169: {
    TIP: '[手枪]',
  },
  170: {
    TIP: '[青蛙]',
  },
  171: {
    TIP: '[茶]',
  },
  172: {
    TIP: '[眨眼睛]',
  },
  173: {
    TIP: '[泪奔]',
  },
  174: {
    TIP: '[无奈]',
  },
  175: {
    TIP: '[卖萌]',
  },
  176: {
    TIP: '[小纠结]',
  },
  177: {
    TIP: '[喷血]',
  },
  178: {
    TIP: '[斜眼笑]',
  },
  179: {
    TIP: '[doge]',
  },
  180: {
    TIP: '[惊喜]',
  },
  181: {
    TIP: '[骚扰]',
  },
  182: {
    TIP: '[笑哭]',
  },
  183: {
    TIP: '[我最美]',
  },
  184: {
    TIP: '[河蟹]',
  },
  185: {
    TIP: '[羊驼]',
  },
  186: {
    TIP: '[栗子]',
  },
  187: {
    TIP: '[幽灵]',
  },
  188: {
    TIP: '[蛋]',
  },
  189: {
    TIP: '[马赛克]',
  },
  190: {
    TIP: '[菊花]',
  },
  191: {
    TIP: '[肥皂]',
  },
  192: {
    TIP: '[红包]',
  },
  193: {
    TIP: '[大笑]',
  },
  194: {
    TIP: '[不开心]',
  },
  195: {
    TIP: '[啊]',
  },
  196: {
    TIP: '[QQ表情冷汗]',
  },
  197: {
    TIP: '[冷漠]',
  },
  198: {
    TIP: '[呃]',
  },
  199: {
    TIP: '[好棒]',
  },
  200: {
    TIP: '[拜托]',
  },
  201: {
    TIP: '[点赞]',
  },
  202: {
    TIP: '[无聊]',
  },
  203: {
    TIP: '[托脸]',
  },
  204: {
    TIP: '[吃]',
  },
  205: {
    TIP: '[送花]',
  },
  206: {
    TIP: '[害怕]',
  },
  207: {
    TIP: '[花痴]',
  },
  208: {
    TIP: '[小样儿]',
  },
  209: {
    TIP: '[脸红]',
  },
  210: {
    TIP: '[飙泪]',
  },
  211: {
    TIP: '[我不看]',
  },
  212: {
    TIP: '[托腮]',
  },
  213: {
    TIP: '[哇哦]',
  },
  245: {
    TIP: '[加油必胜]',
  },
  246: {
    TIP: '[加油抱抱]',
  },
  247: {
    TIP: '[口罩护体]',
  },
  260: {
    TIP: '[搬砖中]',
  },
  261: {
    TIP: '[忙到飞起]',
  },
  262: {
    TIP: '[脑阔疼]',
  },
  263: {
    TIP: '[沧桑]',
  },
  264: {
    TIP: '[捂脸]',
  },
  265: {
    TIP: '[辣眼睛]',
  },
  266: {
    TIP: '[哦哟]',
  },
  267: {
    TIP: '[头秃]',
  },
  268: {
    TIP: '[问号脸]',
  },
  269: {
    TIP: '[暗中观察]',
  },
  270: {
    TIP: '[emm]',
  },
  271: {
    TIP: '[吃瓜]',
  },
  272: {
    TIP: '[呵呵哒]',
  },
  273: {
    TIP: '[我酸了]',
  },
  274: {
    TIP: '[太难了]',
  },
};
// 判断是否为表情
function isFaceTip(index) {
  return !!faceTipMap[index];
}
// QQ表情文本映射
function faceTipEscape(index: number) {
  const numIndex = FaceDict.faceIndex.indexOf(index);
  let msg = '';
  if (numIndex > -1) {
    msg = (FaceDict.faceLocale[index] && `[${i18n.tc(FaceDict.faceLocale[index])}]`) || '';
  }
  return msg || (isFaceTip(index) && `[${i18n.tc('custom_Face')}]`);
}

function faceIndexEscape(face) {
  let number: any = null;
  // Object.keys(faceTipMap).forEach((index) => {
  //   if (faceTipMap[index] && faceTipMap[index].TIP === face) {
  //     number = index;
  //   }
  // });
  FaceDict.faceLocale.forEach((element, index) => {
    if (i18n.tc(element) === face) {
      number = FaceDict.faceIndex[index];
    }
  });
  return number ? Number(number) : null;
}

function coverEmojiIndex2ImgMessage(text) {
  // 这里是通过解析字符串取拼接一个[{text},{face},{text}]的消息，返回这样的消息数组
  const message: any[] = [];
  let temp = text;
  let left = -1;
  let right = -1;
  while (temp !== '') {
    left = temp.indexOf('[');
    right = temp.indexOf(']');
    switch (left) {
      case 0:
        if (right === -1) {
          message.push({
            type: 'text',
            content: temp,
          });
          temp = '';
        } else {
          // 找到表情的索引值
          const emojiNum = temp.slice(left + 1, right);
          const emojiIndex = faceIndexEscape(`${emojiNum}`);
          if (emojiIndex !== null) {
            // 转化为图片url
            message.push({
              type: 'face',
              index: emojiIndex,
              content: `[${emojiNum}]`,
            });
            temp = temp.substring(right + 1);
          } else {
            message.push({
              type: 'text',
              content: '[',
            });
            temp = temp.slice(1);
          }
        }
        break;
      case -1:
        message.push({
          type: 'text',
          content: temp,
        });
        temp = '';
        break;
      default:
        message.push({
          type: 'text',
          content: temp.slice(0, left),
        });
        temp = temp.substring(left);
        break;
    }
  }
  return message;
}

// 过滤html标签保留部分内容
function filterHTML(html: string, acceptable = 'a'): string {
  // 处理数字人下发的文本中含有动作标签时的情况 <insert-action type="动作标签英文"/>
  // eslint-disable-next-line no-param-reassign
  html = htmlFilter.filterAISpeakerActionTag(html);

  return html.replace(/<\/?[^>]+?>/ig, (tag: string): string => {
    if (tag === `</${acceptable}>` || tag.indexOf(`<${acceptable} `) === 0) {
      return tag;
    }
    return tag.replace('<', '&lt;').replace('>', '&gt;');

    return '';
  });
}
function coverEmojIndex2EmojiImg(text) :string {
  const reg = /\[([^]+?)\]/g;
  const newText = text.replace(reg, (emojiStr, emojiName) => {
    if (emojiName.indexOf('f_') === 0) {
      const numIndex = Number((emojiName.split('_')[1]));
      const index = FaceDict.faceIndex.indexOf(numIndex);
      if (index !== -1) {
        // let emojiUrl = 'https://webpage.qidian.qq.com/qidian/chatClient/release/comp/img/qq/';
        // if (location.hostname === 'oaadmin.qidian.qq.com') {
        //   emojiUrl = 'https://oawebpage.qidian.qq.com/qidian/chatClient/release/comp/img/qq/';
        // }
        return `<img src="./static/qq/${index}.png" class="emojiText-image" />`;
      }
      // if (~index && FaceDict.faceHumen[index]) {
      //   return `[${FaceDict.faceHumen[index]}]`;
      // };
      // if (faceTipEscape(strIndex)) {
      //   return faceTipEscape(strIndex);
      // };
      if (isFaceTip(numIndex)) {
        return i18n.tc('custom_Face');
      }
      return emojiStr;
    }

    return emojiStr;
  });

  return newText;
}
// 将页面的[f_13]等转换成[微笑]
export function coverEmojIndex2EmojiName(text) {
  const reg = /\[([^]+?)\]/g;
  const faceDict:any = FaceDict;
  const newText = text.replace(reg, (emojiStr, emojiName) => {
    if (emojiName.indexOf('f_') === 0) {
      const strIndex = Number((emojiName.split('_')[1]));
      const index = faceDict.faceIndex.indexOf(strIndex);
      if (~index && faceDict.faceLocale[index]) {
        return `[${i18n.tc(faceDict.faceLocale[index])}]`;
      };
      if (isFaceTip(strIndex)) {
        return i18n.tc('');
      };
    }

    return emojiStr;
  });

  return newText;
}

/**
 * 对象数据拼接为URL参数 '&key1=value1&key2=value2'
 * @param {obj}} url 参数对象
 */
function objToUrlParams(obj): string {
  let str = '';
  Object.keys(obj).forEach((key) => {
    str = `${str}&${key}=${obj[key]}`;
  });
  return str;
}

export default {
  htmlEscape,
  emojiEscape,
  urlEscape,
  faceTipEscape,
  generateUUID,
  filterHTML,
  coverEmojiIndex2ImgMessage,
  coverEmojIndex2EmojiImg,
  coverEmojIndex2EmojiName,
  objToUrlParams,
  isFaceTip,
};
